import { apiBaseUrl } from '../../config'
import store from '../../store'

// getters
const getters = {
  projects: state => state.projects,
  selectedProject: state => state.project
}

const actions = {
  loadProjects(context) {
    return new Promise((resolve, reject) => {
      fetch(`${apiBaseUrl}/api/projects?token=${store.state.user.token}`, {
        method: "get"
      }).then(res => {
        return res.json()
      }).then(function(data) {
        data.map(item => {
          item.edit = false
        })
        context.commit('loadProjects', data)
        resolve()
      }).catch(e => {
        context.commit('loadProjects', [])
        console.error(e)
        reject()
      });
    })
  },
  createProject(context, data) {
    return new Promise((resolve, reject) => {
      fetch(`${apiBaseUrl}/api/projects?token=${store.state.user.token}`, {
        method: "post",
        headers: {
          "Content-type": "application/json"
        },
        body: JSON.stringify(data)
      }).then(res => {
        return res.json()
      }).then(function(data) {
        context.commit('createProject', data)
        resolve()
      }).catch(e => {
        console.error(e)
        reject()
      });
    })
  },
  saveProject(context, data) {
    return new Promise((resolve, reject) => {
      fetch(`${apiBaseUrl}/api/projects?token=${store.state.user.token}`, {
        method: "put",
        headers: {
          "Content-type": "application/json"
        },
        body: JSON.stringify(data)
      }).then(() => {
        context.commit('saveProject', data)
        resolve()
      }).catch(e => {
        console.error(e)
        reject()
      });
    })
  },
  deleteProject(context, project) {
    return new Promise((resolve, reject) => {
      fetch(`${apiBaseUrl}/api/projects?token=${store.state.user.token}`, {
        method: "delete",
        headers: {
          "Content-type": "application/json"
        },
        body: JSON.stringify(project)
      }).then(res => {
        return res.json()
      }).then(function(data) {
        data.map(item => {
          item.edit = false
        })
        context.commit('deleteProject', data)
        resolve()
      }).catch(e => {
        console.error(e)
        reject()
      });
    })
  },
  setProject(context, project) {
    context.commit('setProject', project)
  },
  cloneProject(context, projectId) {
    return new Promise((resolve, reject) => {
      fetch(`${apiBaseUrl}/api/projects/clone?token=${store.state.user.token}&id=${projectId}`, {
        method: "get"
      }).then(res => {
        return res.json()
      }).then(function(data) {
        context.commit('loadProjects', data)
        resolve()
      }).catch(e => {
        context.commit('loadProjects', [])
        console.error(e)
        reject()
      });
    })
  }
}

const mutations = {
  setProject(state, project) {
    state.projects.map(item => {
      if (item.id === project.id && !project.visible) {
        project.visible = true
      } else {
        item.visible = false
      }
    })
    Object.assign(state.project, project)
  },
  loadProjects(state, projects) {
    projects.map(project => {
      if (state.project.id === project.id && state.project.visible) {
        project.visible = true
      }
      project.edit = false
    })

    state.projects = projects
  },
  createProject(state, project) {
    project.edit = false
    project.visible = true
    state.projects.unshift(project)
    Object.assign(state.project, project)
  },
  saveProject(state, project) {
    project.edit = false
    project.visible = false
    Object.assign(state.project, project)
    state.projects.map(a => {
      if (a.id === project.id) {
        Object.assign(a, project)
      }
    });
  },
  deleteProject(state, projects) {
    state.projects = projects
    Object.assign(state.project, {
      title: '',
      src: '',
      content: [],
      visible: false
    })
  }
}
export default {
  state: initializeState(),
  mutations,
  actions,
  getters
}

function initializeState() {
  return {
    projects: [],
    project: {
      title: '',
      src: '',
      content: [],
      visible: false
    }
  }
}
